<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'invoice-customer-fixed-price-cancel',
};
</script>
